export enum IconEnum {
  BairesDev = 'BairesDev',
  DedicatedTeams = 'DedicatedTeams',
  StaffAugmentation = 'StaffAugmentation',
  SoftwareOutsourcing = 'SoftwareOutsourcing',
}

type IconType = keyof typeof IconEnum;

type Maybe<T> = T | null;

export default interface MenuItem {
  id: string;
  path: string;
  label: string;
  description?: string;
  icon?: IconType;
  children: MenuItem[];
  rel?: Maybe<string> | undefined;
}
